import * as Types from '@praceprofirmy/shared-domain';

import { gql } from 'apollo-angular';
import { CalendarEventFragmentDoc } from './calendar-event-fragment.g';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type CreateCalendarEventMutationVariables = Types.Exact<{
  createCalendarEventInput: Types.CreateCalendarEventInput;
}>;


export type CreateCalendarEventMutation = { __typename?: 'Mutation', createCalendarEvent: { __typename?: 'CalendarEvent', id: string, name: string, description?: string | null, startTime: string, endTime: string, status: Types.CallendarEventStatus, priority: Types.CallendarEventPriority, type: Types.CalendarEventType, color?: string | null, createdAt: string, editedAt?: string | null, createdBy: string, editedBy?: string | null, organizationId: string, participants: Array<{ __typename?: 'CalendarEventParticipant', id: string, participantId: string }> } };

export type UpdateCalendarEventMutationVariables = Types.Exact<{
  updateCalendarEventInput: Types.UpdateCalendarEventInput;
}>;


export type UpdateCalendarEventMutation = { __typename?: 'Mutation', updateCalendarEvent: { __typename?: 'CalendarEvent', id: string, name: string, description?: string | null, startTime: string, endTime: string, status: Types.CallendarEventStatus, priority: Types.CallendarEventPriority, type: Types.CalendarEventType, color?: string | null, createdAt: string, editedAt?: string | null, createdBy: string, editedBy?: string | null, organizationId: string, participants: Array<{ __typename?: 'CalendarEventParticipant', id: string, participantId: string }> } };

export type RemoveCalendarEventMutationVariables = Types.Exact<{
  id: Types.Scalars['String']['input'];
}>;


export type RemoveCalendarEventMutation = { __typename?: 'Mutation', removeCalendarEvent: { __typename?: 'CalendarEvent', id: string, name: string, description?: string | null, startTime: string, endTime: string, status: Types.CallendarEventStatus, priority: Types.CallendarEventPriority, type: Types.CalendarEventType, color?: string | null, createdAt: string, editedAt?: string | null, createdBy: string, editedBy?: string | null, organizationId: string, participants: Array<{ __typename?: 'CalendarEventParticipant', id: string, participantId: string }> } };

export type GetCalendarEventsQueryVariables = Types.Exact<{
  filter?: Types.InputMaybe<Types.FilterInput>;
}>;


export type GetCalendarEventsQuery = { __typename?: 'Query', calendarEvents: Array<{ __typename?: 'CalendarEvent', id: string, name: string, description?: string | null, startTime: string, endTime: string, status: Types.CallendarEventStatus, priority: Types.CallendarEventPriority, type: Types.CalendarEventType, color?: string | null, createdAt: string, editedAt?: string | null, createdBy: string, editedBy?: string | null, organizationId: string, participants: Array<{ __typename?: 'CalendarEventParticipant', id: string, participantId: string }> }> };

export type GetMyCalendarEventsQueryVariables = Types.Exact<{
  filter?: Types.InputMaybe<Types.FilterInput>;
}>;


export type GetMyCalendarEventsQuery = { __typename?: 'Query', myCalendarEvents: Array<{ __typename?: 'CalendarEvent', id: string, name: string, description?: string | null, startTime: string, endTime: string, status: Types.CallendarEventStatus, priority: Types.CallendarEventPriority, type: Types.CalendarEventType, color?: string | null, createdAt: string, editedAt?: string | null, createdBy: string, editedBy?: string | null, organizationId: string, participants: Array<{ __typename?: 'CalendarEventParticipant', id: string, participantId: string }> }> };

export const CreateCalendarEventDocument = gql`
    mutation CreateCalendarEvent($createCalendarEventInput: CreateCalendarEventInput!) {
  createCalendarEvent(createCalendarEventInput: $createCalendarEventInput) {
    ...CalendarEventFragment
  }
}
    ${CalendarEventFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateCalendarEventGQL extends Apollo.Mutation<CreateCalendarEventMutation, CreateCalendarEventMutationVariables> {
    document = CreateCalendarEventDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateCalendarEventDocument = gql`
    mutation UpdateCalendarEvent($updateCalendarEventInput: UpdateCalendarEventInput!) {
  updateCalendarEvent(updateCalendarEventInput: $updateCalendarEventInput) {
    ...CalendarEventFragment
  }
}
    ${CalendarEventFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateCalendarEventGQL extends Apollo.Mutation<UpdateCalendarEventMutation, UpdateCalendarEventMutationVariables> {
    document = UpdateCalendarEventDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RemoveCalendarEventDocument = gql`
    mutation RemoveCalendarEvent($id: String!) {
  removeCalendarEvent(id: $id) {
    ...CalendarEventFragment
  }
}
    ${CalendarEventFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class RemoveCalendarEventGQL extends Apollo.Mutation<RemoveCalendarEventMutation, RemoveCalendarEventMutationVariables> {
    document = RemoveCalendarEventDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetCalendarEventsDocument = gql`
    query GetCalendarEvents($filter: FilterInput) {
  calendarEvents(filter: $filter) {
    ...CalendarEventFragment
  }
}
    ${CalendarEventFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCalendarEventsGQL extends Apollo.Query<GetCalendarEventsQuery, GetCalendarEventsQueryVariables> {
    document = GetCalendarEventsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetMyCalendarEventsDocument = gql`
    query GetMyCalendarEvents($filter: FilterInput) {
  myCalendarEvents(filter: $filter) {
    ...CalendarEventFragment
  }
}
    ${CalendarEventFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetMyCalendarEventsGQL extends Apollo.Query<GetMyCalendarEventsQuery, GetMyCalendarEventsQueryVariables> {
    document = GetMyCalendarEventsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }